module.exports = __webpack_public_path__ + "img/gal_11.740b9ca8.png";